'use strict';

exports.__esModule = true;
exports.TableCell = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TableRow = require('../TableRow');

var _TableRow2 = _interopRequireDefault(_TableRow);

var _ = require('../../..');

var _2 = _interopRequireDefault(_);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure undefined");
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var TableCell = exports.TableCell = (_temp = _class = function (_EditorComponent) {
  _inherits(TableCell, _EditorComponent);

  function TableCell() {
    _classCallCheck(this, TableCell);

    return _possibleConstructorReturn(this, _EditorComponent.apply(this, arguments));
  }

  TableCell.prototype.renderPanelView = function renderPanelView(content) {
    var _getEditorContext = this.getEditorContext(),
        classes = _getEditorContext.classes;

    return _EditorComponent.prototype.renderPanelView.call(this, content || _react2.default.createElement('div', {
      className: classes.panelButton
    }, 'TableCell'));
  };

  TableCell.prototype.getRootElement = function getRootElement() {
    var _getComponentProps = this.getComponentProps(this),
        tag = _getComponentProps.tag;

    return tag || "td";
  };

  TableCell.prototype.canBeParent = function canBeParent(parent) {
    return parent instanceof _TableRow2.default;
  };

  TableCell.prototype.canBeChild = function canBeChild(child) {
    return _EditorComponent.prototype.canBeChild.call(this, child);
  };

  TableCell.prototype.renderMainView = function renderMainView() {
    var _getEditorContext2 = this.getEditorContext(),
        inEditMode = _getEditorContext2.inEditMode;

    var inEditModeProps = void 0;

    if (inEditMode) {
      var _getComponentProps2 = this.getComponentProps(this),
          style = _getComponentProps2.style;

      inEditModeProps = {
        style: _extends({}, style, {
          flex: 1
        })
      };
    }

    return _EditorComponent.prototype.renderMainView.call(this, inEditModeProps);
  };

  TableCell.prototype.renderChildren = function renderChildren() {
    _objectDestructuringEmpty(this.context);

    var _getEditorContext3 = this.getEditorContext();

    _objectDestructuringEmpty(_getEditorContext3);

    var _getComponentProps3 = this.getComponentProps(this),
        other = _objectWithoutProperties(_getComponentProps3, []);

    return _EditorComponent.prototype.renderChildren.call(this);
  };

  return TableCell;
}(_2.default), _class.Name = 'TableCell', _class.defaultProps = _extends({}, _2.default.defaultProps, {
  rowSpan: undefined,
  colSpan: undefined,
  tag: "td"
}), _class.propTypes = _extends({}, _2.default.propTypes, {
  tag: _propTypes2.default.oneOf(["td", "th"]).isRequired
}), _temp);
exports.default = TableCell;